import React from 'react'

function HeightPlayersStats(teams) {

  const getHeightPlayersStats = () => {
    
    return Array.from(teams.teams
      .flatMap(team => team.players))
      .filter(player => player !== undefined)
      .map(player => ({
        name: player.name,
        photo: player.urlPhoto,
        nameText:  '<img class="photo" src="'+player.urlPhoto+'" alt="'+player.urlPhoto+'"></img>&nbsp;' + player.name,
        height: player.height,
      }))
      .sort((a, b) => {
        return b.height - a.height;
      })

  }
  const getTopHeightPlayersStats = () => {
    return getHeightPlayersStats().slice(0, 6);
  }
  const getBottomHeightPlayersStats = () => {
    return getHeightPlayersStats().sort((a, b) => {
      return a.height - b.height;
    }).slice(0, 6);
  }

  const getAverageHeight = () => {
    const heights = getHeightPlayersStats().map(player => player.height);
    const totalHeight = heights.reduce((sum, height) => sum + height, 0);
    return (totalHeight / heights.length).toFixed(2);
  }
  return (
    <div>
      <p>Altura media de los jugadores: {getAverageHeight()} m</p>
      <p><b>Jugadores con mayor altura</b></p>
      <table className="table-stats">
        <thead>
          <tr>
            <th>Jugador</th>
            <th>Altura</th>
          </tr>
        </thead>
        <tbody>
        {getTopHeightPlayersStats().map((item, index) => (
            <tr key={index}>
              <td><div className="label-player" dangerouslySetInnerHTML={{ __html: item.nameText }}></div></td><td className="td-value"> {item.height} m</td>
            </tr>
          ))}
        </tbody>
      </table>

      <p><b>Jugadores con menor altura</b></p>
      <table className="table-stats">
        <thead>
          <tr>
            <th>Jugador</th>
            <th>Altura</th>
          </tr>
        </thead>
        <tbody>
        {getBottomHeightPlayersStats().map((item, index) => (
            <tr key={index}>
              <td><div className="label-player" dangerouslySetInnerHTML={{ __html: item.nameText }}></div></td><td className="td-value"> {item.height} m</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

export default HeightPlayersStats